import { render, staticRenderFns } from "./TasksTableV3.vue?vue&type=template&id=26aeb4e2&scoped=true&lang=pug"
import script from "./TasksTableV3.vue?vue&type=script&lang=ts"
export * from "./TasksTableV3.vue?vue&type=script&lang=ts"
import style0 from "./TasksTableV3.vue?vue&type=style&index=0&id=26aeb4e2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aeb4e2",
  null
  
)

export default component.exports